
import Entry from "./Entry.js";

/*------------------- AMPHIBIANS -------------------*/

const PSSI = new Entry(
    "PSSI",
    "Pseudacris sierra",
    "Pacific chorus frog",
    "amphibians",
    2,
    false,
    "Pacific chorus frogs can be found in moist environments, especially around Lake Lagunita. Usually, they are hiding under a cover object, such as a utility box or log, but they can also be found in the grass. They are prolific in ponds at the Dish, but these are not open to public access without a Foothills Permit.",
    "insects and arthropods",
    "The Pacific chorus frog is a small frog with a dark eye stripe. They can vary in color from brown to bright green, and they are capable of changing between these colors in the space of only a couple hours. Males produce a loud “ribbit”-like call. If you see a frog on campus, it is almost certainly a Pacific chorus frog!",
    "PSSI-1.JPG",
    "Stanford Conservation Program",
    "photoJuvenile",
    "photo2credit"
);

const ANBO = new Entry(
    "ANBO",
    "Anaxyrus boreas",
    "Western toad",
    "amphibians",
    2,
    false,
    "Western toads can be found in moist parts of campus, such as Lake Lag and surrounding areas, as well as the Dish. They tend to venture further from water than Pacific chorus frogs. They often seek cover objects such as logs and boards.",
    "insects and arachnids",
    "The Western toad is a medium-sized, warty toad with a stout body and wide head. They can exhibit a range of colors from green-brown to reddish-brown, and they often have a thin, light colored stripe from their nose to their rear end. Their call is a faint, high pitched trill, almost inaudible to human ears. If you see a toad on campus, it is almost certainly a Western toad!",
    "ANBO-1.jpg",
    "Stanford Conservation Program",
    "photoJuvenile",
    "photo2credit"
);

const BAAT = new Entry(
    "BAAT",
    "Batrachoceps attenuatus",
    "California slender salamander",
    "amphibians",
    2,
    false,
    "Slender salamanders breathe through their skin, which requires them to live in moist environments. They can be found under cover objects and in leaf litter, especially in more forested and shady parts of campus. ",
    "tiny mites, spiders, and snails",
    "The California slender salamander is a teeny tiny salamander with a long body, short limbs, and a worm-like appearance. They are generally black or dark in color, and can have a lighter colored dorsal stripe.",
    "BAAT-1.jpg",
    "Stanford Conservation Program",
    "photoJuvenile",
    "photo2credit"
)

const AMCA = new Entry(
    "AMCA",
    "Ambystoma californica",
    "California tiger salamander",
    "amphibians",
    3,
    true,
    "California tiger salamanders live primarily in burrows and tunnels built by ground squirrels. On rainy winter nights, they leave their burrows and walk, in the open, to a body of water for mating. You are unlikely to observe CTS on campus without a Foothills Permit.",
    "invertebrates",
    "California tiger salamanders are large and stout with protuberant eyes. They have lustrous black skin with bright yellow spots. ",
    "AMCA-1.jpg",
    "Stanford Conservation Program",
    "photoJuvenile",
    "photo2credit"
)

const CRLF = new Entry(
    "CRLF",
    "Rana draytonii",
    "California red-legged frog",
    "amphibians",
    3,
    true,
    "On campus, Red-legged frogs are found primarily in pooling areas within creeks, such as Los Trancos, Matador, and San Francisquito. You are unlikely to observe a California Red-legged frog without a Foothills Permit.",
    "wide variety of invertebrates and sometimes small vertebrates (mice, frogs, fish)",
    "California Red-legged frogs are medium-sized with a slim waist, long legs, and webbed rear feet. They are usually brown to reddish-brown in color, with black speckles on the dorsal side. The underside of their rear legs and belly is red in color, which gives the frog its name.",
    "CRLF-1.jpg",
    "Stanford Conservation Program",
    "photoJuvenile",
    "photo2credit"
)

/*------------------- REPTILES -------------------*/

const SCOC = new Entry(
    "SCOC",
    "Sceloporus occidentalis",
    "Western fence lizard",
    "reptiles",
    1,
    false,
    "Fence lizards prefer open, sunny areas and can often be found sunbathing on logs, fences, and rocks. They are prolific around the Arizona Cactus Garden. You are also likely to see fence lizards around the Lake and nearby neighborhoods, as well as the Arboretum and other less developed parts of campus.",
    "small, terrestrial invertebrates",
    "Western fence lizards are typically small and covered in rough-looking scales. Usually, they have a blotchy tan-to-brown or gray color. Males have bright blue markings on the sides and undersides of the belly, giving them the local nickname 'blue bellies.'",
    "scoc-1.JPG",
    "Stanford Conservation Program",
    "photoJuvenile",
    "photo2credit"
)

const EGMU = new Entry(
    "EGMU",
    "Elgaria multicarinata multicarinata",
    "California alligator lizard",
    "reptiles",
    2,
    false,
    "Alligator lizards are common in grasslands and forests. They are usually found hiding under cover objects, like logs, boards, and rocks.",
    "small vertebrates and invertebrates, bird eggs",
    "California alligator lizards have a thick, round body, short legs, and a long tail. They have shiny scales which appear more snakelike than the Western fence lizard’s. They are brown-to-tan in color and can have red splotches.",
    "EGMU-1.JPG",
    "Stanford Conservation Program",
    "photoJuvenile",
    "photo2credit"
)

const THSI = new Entry(
    "THSI",
    "Thamnophis sirtalis",
    "Intergrade garter snake",
    "reptiles",
    3,
    false,
    "Populations of our subspecies are generally found near permanent (or nearly permanent) water features, such as ponds and creek pools, with heavily vegetated shores. Keep an eye out near Lake Lagunita and the surrounding areas.",
    "primarily frogs",
    "Garter snakes are medium-sized, slender snakes. The garter snakes on Stanford’s campus are an intergrade species between the Red-sided garter snake and the San Francisco garter snake. Our intergrade garter snakes have red-orange heads with light blue dorsal stripes and alternating red and black markings. These patterns are often bright and starkly beautiful.",
    "THSI-1.jpg",
    "Stanford Conservation Program",
    "photoJuvenile",
    "photo2credit"
)

const PICA = new Entry(
    "PICA",
    "Pituophis catenifer catenifer",
    "Pacific gopher snake",
    "reptiles",
    2,
    false,
    "Gopher snakes can be found in a broad variety of habitats from grassland to woodland to suburbia. They may be found sunbathing or hiding under cover objects. Keep an eye out when walking around the Lake Lag or Dish trails!",
    "mostly small mammals, like pocket gophers and mice, as well as birds and bird eggs",
    "Pacific gopher snakes are large snakes with keeled scales and a head that is slightly wider than the neck. They are typically tan in color, with square brown blotches along the length of the body. Sometimes, when threatened, they mimic rattlesnakes by shaking their tail and hissing, but they are not venomous and generally harmless.",
    "PICA-1.jpg",
    "Stanford Conservation Program",
    "photoJuvenile",
    "photo2credit"
)

/*------------------- BIRDS -------------------*/

const JUHY = new Entry(
    "JUHY",
    "Junco hyemalis",
    "Dark-eyed junco",
    "birds",
    1,
    false,
    "Look down! Dark-eyed juncos can be seen all over campus, usually living in and foraging around shrubbery. They are probably the bird you see the most frequently while living at Stanford.",
    "seeds and insects",
    "The Dark-eyed junco is a small, New World sparrow. They typically have dark or gray heads and brown wings and backs. Their calls include ticks and high pitched chips.",
    "JUHY-1.jpeg",
    "Photo by [Ross Millikan](https://www.inaturalist.org/photos/178619696?size=small), licensed under [CC BY-NC 4.0](https://creativecommons.org/licenses/by-nc/4.0/legalcode)",
    "photoJuvenile",
    "photo2credit"
)

const BUJA = new Entry(
    "BUJA",
    "Buteo jamaicensis",
    "Red-tailed hawk",
    "birds",
    1,
    false,
    "Look up! The Red-tailed hawk is the most common bird of prey observed on Stanford’s campus. You are most likely to see them flying, but they may also be seen perched on trees, power lines, and light poles.",
    "mammals like voles, rabbits, and ground squirrels",
    "Red-tailed hawks are large raptors with rounded wings. They can vary widely in color, but they often have a rich, tawny base color and a light, red-toned tail with stripes, when viewed from underneath.",
    "BUJA-1.jpeg",
    "Photo by [Jonathan Eisen](https://www.inaturalist.org/photos/179683629?size=original), licensed under [CC BY 4.0](https://creativecommons.org/licenses/by/4.0/legalcode)",
    "photoJuvenile",
    "photo2credit"
)

const FAPE = new Entry(
    "FAPE",
    "Falco peregrinus",
    "Peregrine falcon",
    "birds",
    2,
    false,
    "Peregrine falcons are often found nesting on urban structures. At Stanford, we have a pair of peregrine falcons that nests on Hoover Tower.",
    "medium-sized birds, typically captured in flight",
    "The peregrine falcon is a crow-sized raptor with a gray back, long black-tipped wings, a slender body, and barred underwings and underbelly.",
    "FAPE-1.jpeg",
    "Photo by [w_fran](https://www.inaturalist.org/photos/248646748?size=small), licensed under [CC BY-NC 4.0](https://creativecommons.org/licenses/by-nc/4.0/legalcode)",
    "photoJuvenile",
    "photo2credit"
)

const HIRU = new Entry(
    "HIRU",
    "Hirundo rustica",
    "Barn swallow",
    "birds",
    1,
    false,
    "Barn swallows are often found nesting in palm trees on Stanford’s campus.",
    "insects like moths, flies, and grasshoppers",
    "Barn swallows are small birds with broad shoulders and pointed wings. They have deep, rusty red faces and throats with bright, steely blue heads, backs, and wings.",
    "HIRU-1.jpeg",
    "Photo by [Andrew Simon] (https://www.inaturalist.org/photos/132790416?size=original)",
    "photoJuvenile",
    "photo2credit"
)

const ATCU = new Entry(
    "ATCU",
    "Athene cunicularia",
    "Western burrowing owl",
    "birds",
    3,
    true,
    "Western burrowing owls overwinter on Stanford’s foothills. Take winter walks at the Dish in the late afternoon or early evening, and you may be lucky enough to spot one!",
    "large insects and small mammals",
    "Western burrowing owls are small, cute, ground-dwelling owls with bright yellow eyes and long legs. They typically have brown bodies speckled with white or buff feathers and a white or buff eyebrow.",
    "ATCU-1.jpeg",
    "Photo by [Frank Schulenburg](https://www.inaturalist.org/photos/174343060?size=original), licensed under [CC BY-SA 4.0](https://creativecommons.org/licenses/by-sa/4.0/legalcode)",
    "photoJuvenile",
    "photo2credit"
)

const ARHE = new Entry(
    "ARHE",
    "Ardea herodias",
    "Great blue heron",
    "birds",
    2,
    false,
    "Great blue herons tend to keep to wetland environments and can often be seen around Lake Lagunita, especially when it is full. You may also see them when walking the Dish trail.",
    "fish, amphibians, reptiles, small mammals, small birds",
    "The Great blue heron is a large wetland bird, often 4’ tall. They have long legs, an s-curved neck, and a thick, sharp bill. They have gray-blue feathers, which give a shaggy appearance, and red-brown legs. They often have dark plumage above the eyes, which extends behind the head.",
    "ARHE-1.jpeg",
    "Photo by [Susan Elliott](https://www.inaturalist.org/photos/63557565?size=original), licensed under [CC BY-NC 4.0](https://creativecommons.org/licenses/by-nc/4.0/legalcode)",
    "photoJuvenile",
    "photo2credit"
)

const ARAL = new Entry(
    "ARAL",
    "Ardea alba",
    "Great egret",
    "birds",
    2,
    false,
    "Like other herons, Great egrets tend to stay in wetlands. Keep an eye out at Lake Lagunita, especially when it is full. You may also see them while walking the Dish trail.",
    "fish, crustaceans, amphibians, small mammals",
    "Great egrets are entirely white water birds with sharp, yellow bills and long, black legs. They are smaller and smoother than Great blue herons.",
    "ARAL-1.jpeg",
    "Photo by [Eric Johnson](https://www.inaturalist.org/photos/152315595?size=original), licensed under [CC BY 4.0](https://creativecommons.org/licenses/by/4.0/)",
    "photoJuvenile",
    "photo2credit"
)

/*------------------- MAMMALS -------------------*/

const THBO = new Entry(
    "THBO",
    "Thomomys bottae",
    "Botta's pocket gopher",
    "mammals",
    2,
    false,
    "Pocket gophers can often be seen constructing their burrows. If you see a fresh mound of dirt around a hole, stay and watch for a minute. You may see a gopher popping his head out! You will have a better chance of seeing these fellas in less developed areas such as the Lake and the Dish.",
    "shoots, grasses, roots, tubers, and bulbs",
    "Botta’s pocket gopher is a cute, native gopher with brown-to-black fur and long, protruding teeth. They construct complex, underground burrows with many chambers. These chambers have designated uses, like nesting, food storage, and defecation.",
    "THBO-1.jpeg",
    "Photo by [Corey Farwell](https://www.inaturalist.org/photos/248770565?size=original), licensed under [CC BY-NC 4.0](https://creativecommons.org/licenses/by-nc/4.0/legalcode)",
    "photoJuvenile",
    "photo2credit"
)

const CALA = new Entry(
    "CALA",
    "Canis latrans",
    "Coyote",
    "mammals",
    2,
    false,
    "Coyotes can be seen wandering at the Dish, the Lake, and other Stanford foothills. They sometimes wander into the Lake House communities. They may be cute, but if you see one nearby, do not attempt to approach it, as all wild animals can be dangerous.",
    "primarily small mammals, also birds and snakes",
    "Coyotes resemble medium-sized, German shepherd-like dogs with pointed ears, a long snout, and a bushy, black-tipped tail. Their fur is typically reddish brown. They give a loud, howling call at night which can be heard up to 3 miles away.",
    "CALA-1.jpeg",
    "Photo by [Don McCullough](https://www.inaturalist.org/photos/29683240?size=original), licensed under [CC BY-NC 4.0](https://creativecommons.org/licenses/by-nc/4.0/legalcode)",
    "photoJuvenile",
    "photo2credit"
)

const LECA = new Entry(
    "LECA",
    "Lepus californicus",
    "Black-tailed jack rabbit",
    "mammals",
    1,
    false,
    "Black-tailed jack rabbits can be seen all over campus, especially in the evenings. They are particularly abundant around Gerhard Casper Quad.",
    "primarily grasses",
    "The Black-tailed jack rabbit is a medium-sized hare with brown fur and a black stripe down its back, which culminates in a black tail. They have large, upright, black-tipped ears and wide eyes.",
    "LECA-1.jpeg",
    "Photo by [Alison Gray](https://www.inaturalist.org/photos/48704143?size=original), licensed under [CC BY-NC 4.0](https://creativecommons.org/licenses/by-nc/4.0/legalcode)",
    "photoJuvenile",
    "photo2credit"
)

const SYBA = new Entry(
    "SYBA",
    "Sylvilagus bachmani",
    "California brush rabbit",
    "mammals",
    2,
    false,
    "These cute bunnies can be seen in chapparal and oak canopy habitats, such as the Dish.",
    "leaves, forbs, and scrubs, such as wild rose, blackberries, and clover",
    "The California brush rabbit is a small, brown-gray rabbit with short legs, a round body, small upright ears, and a white, fluffy tail, characteristic of the cottontail genus (Sylvilagus).",
    "SYBA-1.jpeg",
    "Photo by [Phil Calvert](https://www.inaturalist.org/photos/145763740?size=small), licensed under [CC BY-NC 4.0](https://creativecommons.org/licenses/by-nc/4.0/legalcode)",
    "photoJuvenile",
    "photo2credit"
)

const OTBE = new Entry(
    "OTBE",
    "Otospermophilus beecheyi",
    "California ground squirrel",
    "mammals",
    1,
    false,
    "California ground squirrels live in burrows, which they dig, often in hillsides. They can be found all over campus, especially at the Dish and Lake Lag. If you see a ground squirrel, it's almost certainly a California ground squirrel.",
    "leaves, stems, flowers, seeds, fruit",
    "The California ground squirrel is a small squirrel with brown-to-gray fur and cream flecks on its back. They have long, bushy tails and big eyes.",
    "OTBE-1.jpeg",
    "Photo by [Patti P.](https://www.inaturalist.org/photos/256542311?size=original), licensed under [CC BY-NC 4.0](https://creativecommons.org/licenses/by-nc/4.0/legalcode)",
    "photoJuvenile",
    "photo2credit"
)

const SCGR = new Entry(
    "SCGR",
    "Sciurus griseus",
    "Western gray squirrel",
    "mammals",
    1,
    false,
    "Western gray squirrels live in trees all over campus. While there are two other species of tree squirrel you might observe in the Bay Area, only the Western gray squirrel is native to California.",
    "pinecone seeds, nuts, acorns",
    "Western gray squirrels have gray-to-black fur and long, bushy tails.",
    "SCGR-1.jpeg",
    "Photo by [Mike Cardwell](https://www.inaturalist.org/photos/5181825?size=original), licensed under [CC BY-NC 4.0](https://creativecommons.org/licenses/by-nc/4.0/legalcode)",
    "photoJuvenile",
    "photo2credit"
)

/*------------------- FISH -------------------*/

const ONMY = new Entry(
    "ONMY",
    "Oncorhynchus mykiss",
    "Steelhead trout",
    "fish",
    3,
    true,
    "Steelhead trout live in healthy river and stream ecosystems. On campus, this can include the Los Trancos, San Francisquito, and Matadero Creeks. You are unlikely to see steelhead trout on campus without a Foothills Permit.",
    "zooplankton, fish eggs, small fish, mollusks, insects",
    "Steelhead trout are medium sized, olive colored fish with speckles and a pink-red strip on their sides. Their bodies reflect stunningly beautiful rainbow colors in the sunlight. Like salmon, steelhead trout live in the ocean but spawn in streams. Sometimes, populations become isolated to streams and do not return to the ocean. These populations are called rainbow trout.",
    "ONMY-1.jpeg",
    "Photo by [Philip Georgakakos]()https://www.inaturalist.org/photos/149645469?size=original, licensed under [CC BY-NC 4.0](https://creativecommons.org/licenses/by-nc/4.0/legalcode)",
    "photoJuvenile",
    "photo2credit"
)


const entriesArray = [
    PSSI,
    ANBO,
    BAAT,
    AMCA,
    CRLF,
    SCOC,
    EGMU,
    THSI,
    PICA,
    JUHY,
    BUJA,
    FAPE,
    HIRU,
    ATCU,
    ARHE,
    ARAL,
    THBO,
    CALA,
    LECA,
    SYBA,
    OTBE,
    SCGR,
    ONMY
]

export default entriesArray;

